const PRELOAD_ATTRIBUTE = 'data-ecp-login-logo-preload'
const PRELOAD_SELECTOR = `link[${PRELOAD_ATTRIBUTE}]`

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

const stringField = (value: unknown, key: string) => {
  if (!isRecord(value)) return undefined

  const field = value[key]

  return typeof field === 'string' && field.length > 0 ? field : undefined
}

export const removeLoginLogoPreload = () => {
  document.head.querySelector(PRELOAD_SELECTOR)?.remove()
}

export const syncLoginLogoPreload = (url?: string) => {
  const existing =
    document.head.querySelector<HTMLLinkElement>(PRELOAD_SELECTOR)

  if (!url) {
    existing?.remove()

    return
  }

  const preload = existing ?? document.createElement('link')

  preload.rel = 'preload'
  preload.setAttribute('as', 'image')
  preload.setAttribute('fetchpriority', 'high')
  preload.setAttribute(PRELOAD_ATTRIBUTE, '')

  if (preload.getAttribute('href') !== url) {
    preload.setAttribute('href', url)
  }

  if (!existing) {
    document.head.appendChild(preload)
  }
}

export const bootLogoUrl = (
  themePayload: unknown,
  fallbackLogoUrl?: string
) => {
  const design = isRecord(themePayload) ? themePayload.design : undefined
  const sparkTheme = isRecord(design) ? design.spark_theme : undefined
  const assets = isRecord(sparkTheme) ? sparkTheme.assets : undefined
  const logoUrl = stringField(assets, 'logoUrl')
  const logoDarkUrl = stringField(assets, 'logoDarkUrl')
  const isDark = document.documentElement.classList.contains('dark')
  const assetUrl = (isDark && logoDarkUrl) || logoUrl

  if (assetUrl) return assetUrl

  return typeof fallbackLogoUrl === 'string' && fallbackLogoUrl.length > 0
    ? fallbackLogoUrl
    : undefined
}
